module.exports = __webpack_public_path__ + "2d005f0fef7a2f4a9ba01a743c1c724f.png";